import TR from 'utils/TR';
import useNavAction from 'hooks/actions/useNavAction';
import T from 'utils/T';
import ex from 'utils/ex';
import FocusableButton from 'components/common/FocusableButton';
import React from 'react';
import HBox from 'components/common/HBox';
import ExerciseTabs from './ExerciseTabs';
import DataRatio from '../DataRatio';
import { useSlot } from 'modules/Signals';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

export default function ReportTabs(props) {
  const {
    children,
    ...rest
  } = props;

  const {
    triggered: triggeredReport,
  } = useNavAction('Report', props);

  const {
    triggered: triggeredReportBloodGlocose,
    onTrigger: onTriggerReportBloodGlocose,
  } = useNavAction({ name: 'ReportBloodGlocose' }, props);

  const {
    triggered: triggeredReportExercise,
    onTrigger: onTriggerReportExercise,
  } = useNavAction({ name: 'ReportExercise' }, props);

  const {
    triggered: triggeredReportExerciseSteps,
  } = useNavAction('ReportExerciseSteps', { category: 'Exercise' });

  const {
    triggered: triggeredReportExerciseCalories,
  } = useNavAction('ReportExerciseCalories', { category: 'Exercise' });
  const {
    triggered: triggeredReportDiet,
    onTrigger: onTriggerReportDiet,
  } = useNavAction({ name: 'ReportDiet' }, props);

  const {
    triggered: triggeredReportInsulin,
    onTrigger: onTriggerReportInsulin,
  } = useNavAction({ name: 'ReportInsulin' }, props);


  const [selected, setSelected] = React.useState(0);
  React.useEffect(() => {
    if (!triggeredReport) return;
    const triggers = [
      triggeredReportBloodGlocose,
      triggeredReportExercise,
      triggeredReportDiet,
      triggeredReportInsulin
    ];
    const selected = triggers.findIndex(trigger => trigger);
    setSelected(() => selected);
  }, [triggeredReport, triggeredReportBloodGlocose, triggeredReportDiet, triggeredReportExercise, triggeredReportInsulin]);

  React.useEffect(() => {
    if (!triggeredReport) return;
    const triggers = [
      onTriggerReportBloodGlocose(),
      onTriggerReportExercise(),
      onTriggerReportDiet(),
      onTriggerReportInsulin()
    ];

    const onKeyDown = (e) => {
      switch (e.key) {
        case 'ArrowLeft': {
          const nextSelected = (triggers.length + selected - 1) % triggers.length;
          triggers[nextSelected]();
          document.activeElement?.blur();
          return;
        }
        case 'ArrowRight': {
          const nextSelected = (selected + 1) % triggers.length;
          triggers[nextSelected]();
          document.activeElement?.blur();
          return;
        }
        default:
          return;
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onTriggerReportBloodGlocose, onTriggerReportDiet, onTriggerReportExercise, onTriggerReportInsulin, selected, triggeredReport]);

  const ReportBloodGlocose = Recoil.useRecoilValue(AppStore.assets.data('ReportBloodGlocose'));
  const ReportDiet = Recoil.useRecoilValue(AppStore.assets.data('ReportDiet'));
  const ReportExerciseCalories = Recoil.useRecoilValue(AppStore.assets.data('ReportExerciseCalories'));
  const ReportExerciseSteps = Recoil.useRecoilValue(AppStore.assets.data('ReportExerciseSteps'));
  const ReportInsulin = Recoil.useRecoilValue(AppStore.assets.data('ReportInsulin'));

  const [dataType, setDataType] = React.useState('ReportBloodGlocose');
  const onChangeReportData = React.useCallback((data, type) => {
    setDataType(() => type);
  }, []);
  useSlot('ReportData', onChangeReportData);

  const reports = {
    ReportBloodGlocose,
    ReportDiet,
    ReportExerciseSteps,
    ReportExerciseCalories,
    ReportInsulin,
  };

  const {
    data_reliability,
    data_reliability_yn,
    meal_cnt: active_cnt,
    meal_day_cnt: active_day_cnt,
  } = reports[dataType] || {};

  const onSelect = React.useCallback(() => {
    requestAnimationFrame(() => {
      // document.querySelector('[category="Report"] .PageContent').scrollIntoView({
      //   block: 'start',
      //   inline: 'end',
      // })

      const elem = document.querySelector('.VBox.full:has(>.PageOutlet[category="App"])');
      if (!elem) return;
      elem.scrollTop = 0;
    })
  }, []);

  return (
    <HBox {...ex('ReportTabs', rest)}>
      <HBox>
        <FocusableButton
          {...ex(['ReportButton', { triggered: triggeredReportBloodGlocose }], {
            // disabled: triggeredReportBloodGlocose,
            onClick: onTriggerReportBloodGlocose(onSelect),
          })}
        >
          {T('혈당')}
        </FocusableButton>
        <FocusableButton
          {...ex(['ReportButton', { triggered: triggeredReportDiet }], {
            // disabled: triggeredReportDiet,
            onClick: onTriggerReportDiet(onSelect),
          })}
        >
          {T('식사')}
        </FocusableButton>
        <FocusableButton
          {...ex(['ReportButton', { triggered: triggeredReportExercise }], {
            // disabled: triggeredReportExercise,
            onClick: onTriggerReportExercise(onSelect),
          })}
        >
          {T('활동')}
        </FocusableButton>
        <FocusableButton
          {...ex(['ReportButton', { triggered: triggeredReportInsulin }], {
            // disabled: triggeredReportInsulin,
            onClick: onTriggerReportInsulin(onSelect),
          })}
        >
          {T('인슐린')}
        </FocusableButton>
      </HBox>
      <HBox full between vcenter>
        <div>
          <DataRatio {...{ data_reliability, data_reliability_yn }} >
            {active_cnt && active_day_cnt && T('{0} 건 / {1} 일', active_cnt, active_day_cnt)}
          </DataRatio>
        </div>
        <HBox>
          {triggeredReportExercise && (
            <ExerciseTabs />
          )}
          {children}
        </HBox>
      </HBox>
    </HBox>
  );
}
